





































































































































































































































import { Component, Vue, Provide } from "vue-property-decorator";
import { pagnition } from "@/utils/commonConfig";
import { jsIntString } from "@/utils/index";
import {
  GetRepayCodePageCondReq
} from "@/pbjs/xcommon/ticket_pb";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import { ticketClient } from "@/api/ticketClient";
@Component({
  name: "CombinationProperty",
  filters:{
    filter(value: any, key:any) {
      let str: any = []
      for(let val of value) {
        if (val[1].listList) {
           val[1].listList.forEach((item:any) => {
            if (item.channelid==key) {
              str.push(item.paymentcode)
            } 
           });         
        }
      }
        return str.join(',')
    }
  }
})
export default class CombinationProperty extends Vue {
  @Provide() private resultData: any = [];
  @Provide() private country: any = localStorage.getItem("country"); // 国家，字段差异化展示
  @Provide() private token: any;
  @Provide() private RepaymentCode: any= [];
  @Provide() private AppName: any= [];
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private pagnition: any = pagnition;
  @Provide() private ruleForm: any = {
    OrderId: null,
    CustomerId: null,
    Mobile: null,
    CustomerName: null,
    EAccountNumber: null,
    RepayCode:null,
    AppName:null,
  };
  @Provide() private RepayCodeOpnList:any= [
      // { codeName: "OXXO", code: null, channel: 1 },
      // { codeName: "Paynet", code: null, channel: 2 },
      // { codeName: "Efecty", code: null, channel: 7 },
      // { codeName: "Baloto", code: null, channel: 8 },
      // { codeName: "Bancolombia", code: null, channel: 9 }
    ]
    // @Provide() private RepayCodeOpnListCo:any= [
    //   // { codeName: "OXXO", code: null, channel: 1 },
    //   // { codeName: "Paynet", code: null, channel: 2 },
    //   { codeName: "Efecty", code: null, channel: 7 },
    //   { codeName: "Baloto", code: null, channel: 8 },
    //   { codeName: "Bancolombia", code: null, channel: 9 }
    // ]
  // @Provide() private AppOpnList:any= []
  @Provide() private AppOpnList:any= []
  @Provide() private isGetTicketListActionDone: boolean = false;
  @Provide() private isShowSearchRegion: boolean = true;
  private created() {
    this.token = localStorage.getItem("token");
    this.GetRepayCodePageCondreq()
  }
  private activated() {
  }
  private  GetRepayCodePageCondreq() {
  let request  : any=new GetRepayCodePageCondReq()
   request.setCommonin(setCommon());
   ticketClient.getRepayCodePageCond(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let _fuc = this.RepayCodeFuc;
        handleResponse(data, _fuc);
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
  private RepayCodeFuc(data: any){
     let RepayCodeOpnList=JSON.parse(data.channelcond)
     Object.keys(RepayCodeOpnList).forEach((item:any) => {
       this.RepayCodeOpnList.push({
         codeName: item, code: null, channel: RepayCodeOpnList[item]
       })
     });
     let AppOpnList=JSON.parse(data.applist)
     Object.keys(AppOpnList).forEach((item:any) => {
       this.AppOpnList.push({
         codeName: AppOpnList[item], code: null, channel: item
       })
     });
  }
  private changeRepaymentCode(data: any){
    if (data=='') {
      this.ruleForm.RepayCode=null
    }
  }
  private changeAppName(data: any){
    if (data=='') {
      this.ruleForm.AppName=null
    }
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getTicketList();
  }
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getTicketList();
  }
  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getTicketList();
    }
  }
  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getTicketList();
  }

  private getTicketListAction() {
    this.isGetTicketListActionDone = true;
    this.pageIndex = 1;
    this.getTicketList();
  }

  // 查询输入框显示与否
  private showOrHideSearchRegion() {
    this.isShowSearchRegion = !this.isShowSearchRegion;
  }

  // 查询
  private async getTicketList() {
    const { getRepayCode }: any = await import("@/request/paymentCodeInquire");
    if (this.ruleForm.OrderId && !jsIntString(this.ruleForm.OrderId)) {
      this.$message.error("the orderID must be number!");
      this.isGetTicketListActionDone = false;
      return;
    }

    if (this.ruleForm.CustomerId && !jsIntString(this.ruleForm.CustomerId)) {
      this.$message.error("the CustomerId must be number!");
      this.isGetTicketListActionDone = false;
      return;
    }
    let RepayCodeList:any=[]
      this.RepayCodeOpnList.forEach((item:any) => {
        if (item.channel==this.RepaymentCode) {
           RepayCodeList=[{codeName: item.codeName,code: this.ruleForm.RepayCode, channel: item.channel}]
        }
      }); 

    let AppName:string;
      this.AppOpnList.forEach((item:any) => {
        if (item.channel==this.AppName) {
          AppName=item.channel
        }
      }); 

    let arg = {
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      OrderId: this.ruleForm.OrderId,
      CustomerId: this.ruleForm.CustomerId,
      Mobile: this.ruleForm.Mobile,
      CustomerName: this.ruleForm.CustomerName,
      EAccountNumber: this.ruleForm.EAccountNumber,
      RepayCodeList: RepayCodeList,
      AppName:AppName,
    };
    let res = await getRepayCode(arg, this);
    this.isGetTicketListActionDone = res ? res.loading : false;
    if (res) {
      let _result =
        typeof res.listList == "object"
          ? res.listList
          : JSON.parse(res.listList);
      if (_result) {
        _result.map((item: any) => {
          (item.customerid = item.customerid || "-"),
            (item.customername = item.customername || "-"),
            (item.eaccountnumber = item.eaccountnumber || "-"),
            (item.leftamount = item.leftamount || "0"),
            (item.orderid = item.orderid || "-");
        });
        this.resultData = _result;
      }
      if (res.pageout || res.total) {
        this.pagerCount = res.total ? res.total : res.pageout.total;
      }
    }
  }
}
